import { call, all } from 'redux-saga/effects';

export default function* indexSaga(){
  yield all([])
}
 